import React from 'react';

import GoldRedirectCard from '../GoldRedirectCard';

const ProfileTransferRedirect = () => (
  <GoldRedirectCard routeName="Prelogin" />
);

export default ProfileTransferRedirect;
